export enum StorageKey {
  AccessToken = 'access_token',
  RefreshToken = 'refresh_token',
  SidebarCollapsed = 'sidebar_collapsed',
  MessageListCollapsed = 'message_list_collapsed',
}
